module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/78.2f328f9f.png";